export const WHAT_3_WORDS = 'WHAT3WORDS';
export const TF911_PERMISSION = 'TEXT_FROM_911';
export const MANAGE_COMMUNICATION_PERMISSION = 'MANAGE_COMMUNICATION';
export const APPLE_ADR_PERMISSION = 'APPLE';
export const MEDIA_UPLOAD_PERMISSION = 'MEDIA_UPLOAD';
export const VIDEO_STREAMING_PERMISSION = 'VIDEO_STREAMING';
export const DEVICE_MEDIA_PERMISSION = 'APPLE_DEVICE_MEDIA';
export const SECURE911_PERMISSION = 'SECURE911';
export const COMMUNICATOR_VIDEOCALL_PERMISSION = 'COMMUNICATOR_VIDEOCALL';
export const COMMUNICATOR_LOCATION_REQUEST_PERMISSION =
  'COMMUNICATOR_LOCATION_REQUEST';
export const VT911_PERMISSION = 'VIDEO_TO_911';
export const AIR_AMBULANCE_PERMISSION = 'AIR_AMBULANCE';
export const ROADSIDE_ASSISTANCE_PERMISSION = 'ROADSIDE_ASSISTANCE';
export const COMMUNICATOR_TRANSCRIPTION_PERMISSION =
  'COMMUNICATOR_TRANSCRIPTION';
export const UNITE_SUMMARIZATION_AND_KEYWORDS_PERMISSION =
  'UNITE_SUMMARIZATION_AND_KEYWORDS';
export const UNITE_RADIO_TRANSCRIPTION_PERMISSION = 'UNITE_RADIO_TRANSCRIPTION';
export const UNITE_TRANSCRIPTION_AND_AUDIO_PLAYBACK_PERMISSION =
  'UNITE_TRANSCRIPTION_AND_AUDIO_PLAYBACK';
export const HARMONY_VIDEO_TRANSCRIPTION_AND_TRANSLATION_PERMISSION =
  'HARMONY_VIDEO_TRANSCRIPTION_AND_TRANSLATION';
export const HARMONY_TEXT_TO_VOICE_TRANSLATION_PERMISSION =
  'HARMONY_TEXT_TO_VOICE_TRANSLATION';
